import React from 'react';
import AppointmentForm from '../../components/GetAppointment/AppointmentForm';

const Appointment = () => {
    return (
        <>
            <AppointmentForm />
        </>
    );
};

export default Appointment;